// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__hpRR3","form-group":"LoginPage_form-group__Q7aDC","link":"LoginPage_link__lOVQc"};